import { useEffect, useMemo } from "react";

import { useCurrentUser } from "../hooks/useCurrentUser";
import { createOakStreamClient } from "./cache";

export function useScopedOakStreamClient() {
  const { user } = useCurrentUser();
  const streamOwnerUserId = user?.id ?? null;
  // oxlint-disable-next-line  eslint-plugin-react-hooks(exhaustive-deps)
  const oakStreamClient = useMemo(() => createOakStreamClient(), [streamOwnerUserId]);

  useEffect(() => {
    return () => {
      oakStreamClient.close();
    };
  }, [oakStreamClient]);

  return oakStreamClient;
}
